import { useChatTransport as e } from "../transport/ChatTransportContext.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
//#region src/hooks/useCreateInternalNoteMutation.ts
var r = (r) => {
	let i = n(), { api: a, keys: o } = e();
	return t({
		mutationFn: (e) => a.createInternalNote(r, e),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: o.internalNotes(r) });
		}
	});
};
//#endregion
export { r as useCreateInternalNoteMutation };
